import { HttpService, resolveService } from "@reco-m/core";

export class notificationSceneHttpService extends HttpService {
    constructor() {
        super("notification/scene");
    }
}

export const notificationSceneService = resolveService(notificationSceneHttpService);
